import axios from "axios";
import { ApiResponse, PreapprovalResponse } from "../../pages/register/types";
import { useAuth } from "@/utils/useAuth";

export class extensionService {
  private readonly apiUrl = `${
    import.meta.env.VITE_ENDPOINT_BILLING
  }/subscription/extensions/plans`;
  private readonly unsubscribeUrl = `${
    import.meta.env.VITE_ENDPOINT_BILLING
  }/subscription/unsubscribe`;

  async getExtensionPlans(): Promise<
    {
      plan: PreapprovalResponse;
    }[]
  > {
    try {
      let url = this.apiUrl;

      const response = await axios.get<ApiResponse>(url, {
        headers: {
          Authorization: await useAuth.getUserToken(),
        },
      });

      // Verifica se data existe na resposta e se é um array
      const extensionPlans = response?.data?.data || [];
      console.log("Planos recebidos da API:", response.data);

      const formattedPlans = extensionPlans.map((selectedPlan) => ({
        plan: selectedPlan,
      }));

      return formattedPlans;
    } catch (error) {
      console.error("Erro ao obter os planos de extensão:", error);
      throw error;
    }
  }

  async unsubscribeContract(contractId: string): Promise<any> {
    try {
      const response = await axios.post(
        this.unsubscribeUrl,
        { contractId },
        {
          headers: {
            Authorization: await useAuth.getUserToken(),
          },
        }
      );

      console.log("Resposta da desinscrição do contrato:", response.data);
      return response.data;
    } catch (error) {
      console.error("Erro ao desinscrever o contrato:", error);
      throw error;
    }
  }
}
